import { create } from 'zustand';

import { FloatingButtonType } from '../type';
import { createSelectors } from '../utils/zustand/createSelectors';

interface FloatingButtonState {
  /** 플로팅 버튼 상태 */
  floatingButton: FloatingButtonType;

  /** 플로팅 버튼 상태 설정 */
  setFloatingButton: (type: FloatingButtonType) => void;
}

/**
 * 플로팅 버튼 상태를 관리하는 Zustand store
 * - 채널톡, 레시피 작성 등의 플로팅 버튼 노출 관리
 */
const useFloatingButtonStoreBase = create<FloatingButtonState>((set) => ({
  floatingButton: FloatingButtonType.NULL,
  setFloatingButton: (type: FloatingButtonType) =>
    set(() => ({
      floatingButton: type,
    })),
}));

export const useFloatingButtonStore = createSelectors(
  useFloatingButtonStoreBase,
);
